<ng-container *ngIf="content">
    <p *ngIf="title">{{ title | translate }} <a href="{{getHandle()}}">{{getHandle()}}</a></p>
</ng-container>
